import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { SubCategoryPropsProvider } from './components/stack/hooks/content/useSubCategoryProps';
import { SubCategory } from './components/stack/views/SubCategory/SubCategory';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout, drawDefaultLayout } from './components/layout/DefaultLayout';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('content-hub');
  if (!container) return drawDefaultLayout();

  const root = createRoot(container);
  root.render(
    <BaseContentProvider>
      <SubCategoryPropsProvider>
        <DefaultLayout>
          <SubCategory />
        </DefaultLayout>
      </SubCategoryPropsProvider>
    </BaseContentProvider>
  );
});
